const modularPageExample = () => {
    if ($('.page-id-1708').length) {
        const modules = $('section.module');

        modules.each((i, item) => {
            const moduleName = $(item).data('mod-name');

            if (moduleName) {
                $(item).before(`<div class="d-flex py-5 px-4 mb-5" style="background: #1B449C; color: white; margin-top: 150px;">Module: ${moduleName}</div>`);
            }
        })
    }
}